<template>
  <div class="card custom-card card-primary">
    <div class="candidate">
      <div class="d-flex align-items-center">
        <div class="manager-candidate-img" style="width: 74px; height: 74px; margin-right: 12px">
          <img
            class="rounded-circle"
            v-if="
              getManagerCandidateById.photo !== null &&
                getManagerCandidateById.photo !== 'null' &&
                getManagerCandidateById.photo !== 'default.png'
            "
            :src="
              `https://jobshark.eu/storage/admincandidateavatars/${getManagerCandidateById.photo}`
            "
            alt="candidate avatar"
          />
          <img v-else src="https://jobshark.eu/img/comstream.svg" alt="candidate avatar" />
        </div>
        <div class="candidate-main-info d-flex">
          <div class="candidate-name d-flex">
            <b>{{ getManagerCandidateById.first_name }} {{ getManagerCandidateById.last_name }}</b>
          </div>
        </div>
      </div>
    </div>

    <nav class="job-controls-tabs">
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          class="nav-item nav-link active"
          id="nav-primary-tab"
          data-toggle="tab"
          href="#nav-primary"
          role="tab"
          aria-controls="nav-primary"
          aria-selected="true"
        >
          PROFILE
        </a>
        <a
          class="nav-item nav-link mobile-hidden d-none d-sm-block"
          id="nav-cv-tab"
          data-toggle="tab"
          href="#nav-cv"
          role="tab"
          aria-controls="nav-cv"
          aria-selected="false"
          @click="onCvDocumentView($event)"
        >
          CV
        </a>
        <a
          class="nav-item nav-link mobile-only-new"
          id="nav-doc-tab"
          data-toggle="tab"
          href="#nav-doc"
          role="tab"
          aria-controls="nav-doc"
          aria-selected="false"
        >
          Documents
        </a>
        <a
          class="nav-item nav-link d-none d-sm-block"
          id="nav-comments-tab"
          data-toggle="tab"
          href="#nav-comments"
          role="tab"
          aria-controls="nav-comments"
          aria-selected="false"
        >
          <!--  @click="showCv = false" -->
          <i class="fas fa-comments d-block d-sm-none"></i> COMMENTS
          <span
            v-show="getManagerCandidateComments.length ? true : false"
            class="badge badge-light"
            >{{ getManagerCandidateComments.length }}</span
          >
        </a>
        <a
          class="nav-item nav-link mobile-only"
          id="nav-pipelines-tab"
          data-toggle="tab"
          href="#nav-pipelines"
          role="tab"
          aria-controls="nav-pipelines"
          aria-selected="false"
        >
          <i class="fas fa-sliders-h d-block d-sm-none"></i> Pipelines
        </a>
        <a
          class="nav-item nav-link mobile-only"
          id="nav-activity-tab"
          data-toggle="tab"
          href="#nav-activity"
          role="tab"
          aria-controls="nav-activity"
          aria-selected="false"
        >
          <i class="fas fa-chart-bar d-block d-sm-none"></i> activities
        </a>
        <a
          class="nav-item nav-link mobile-only"
          id="nav-emails-tab"
          data-toggle="tab"
          href="#nav-emails"
          role="tab"
          aria-controls="nav-emails"
          aria-selected="false"
        >
          <i class="fas fa-envelope d-block d-sm-none"></i> Emails
        </a>
      </div>
    </nav>

    <div class="tab-content" id="nav-tabContent">
      <div
        class="tab-pane fade show active"
        id="nav-primary"
        role="tabpanel"
        aria-labelledby="nav-primary-tab"
      >
        <section>
          <form @submit.prevent="updateCandidate" class="candidate-info-form">
            <ul class="list-group list-group-custom candidate-details">
              <div class="row">
                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Primary email</b>
                    </span>

                    <div
                      style="
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: block;
                      "
                    >
                      <a
                        :href="`mailto:${getManagerCandidateById.email}`"
                        target="_top"
                        class="mr-3"
                        >{{ getManagerCandidateById.email }}</a
                      >
                    </div>
                  </div>
                </li>
                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>2nd email</b>
                    </span>
                    <div>
                      <a
                        v-if="getManagerCandidateById.email2"
                        :href="`mailto:${getManagerCandidateById.email2}`"
                        class="mr-3"
                        target="_top"
                        >{{ getManagerCandidateById.email2 }}</a
                      >
                      <span v-else>N/A</span>
                    </div>
                  </div>
                </li>
                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Phone number</b>
                    </span>
                    <div>
                      <span
                        ><a :href="`tel:${getManagerCandidateById.phone}`">{{
                          getManagerCandidateById.phone
                        }}</a></span
                      >
                    </div>
                  </div>
                </li>
                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Street address</b>
                    </span>
                    <div>{{ getManagerCandidateById.address.address || 'N/A' }}</div>
                  </div>
                </li>
                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Postal code</b>
                    </span>
                    <div>{{ getManagerCandidateById.postal || 'N/A' }}</div>
                  </div>
                </li>
                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>City</b>
                    </span>
                    <div v-if="getManagerCandidateById && getManagerCandidateById.city">
                      {{ getManagerCandidateById.city.name || 'N/A' }}
                    </div>
                  </div>
                </li>

                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Country</b>
                    </span>
                    <div v-if="getManagerCandidateById && getManagerCandidateById.country">
                      {{ getManagerCandidateById.country.name || 'N/A' }}
                    </div>
                  </div>
                </li>

                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Relocation</b>
                    </span>

                    <div class="custom-control">
                      <span>{{ relocation ? 'Yes' : 'No' }}</span>
                    </div>
                  </div>
                </li>

                <!-- TODO: This should show Primary CV file on mobile devices -->
                <!--   <li class="list-group-item col-md-6 d-block d-sm-none primary-cv">
                  <div class="d-flex">
                    <span>
                      <b>Primary CV</b>
                    </span>
                    <div>
                      <a :href="defaultCv">
                        <img
                          src="https://cdn3.iconfinder.com/data/icons/line-icons-set/128/1-02-512.png"
                          width="20px"
                          height="20px"
                        />
                        CV_Nabbawl_primary_english
                      </a>
                    </div>
                  </div>
                </li> -->
                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Linkedin</b>
                    </span>
                    <div class="truncate">
                      <a
                        @click="seenProfile()"
                        class="text-nowrap"
                        v-if="getManagerCandidateById.linkedin"
                        :href="checkLinkedIin(getManagerCandidateById.linkedin)"
                        target="_blank"
                        >{{ getManagerCandidateById.linkedin | prettifyUrl }}</a
                      >
                      <span
                        v-else
                        style="color: #0088cc; text-decoration: none; background-color: transparent"
                        >N/A</span
                      >
                    </div>
                  </div>
                </li>
                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Webpage</b>
                    </span>
                    <div class="truncate">
                      <a
                        @click="seenProfile()"
                        v-if="getManagerCandidateById.webpage"
                        :href="`//${getManagerCandidateById.webpage}`"
                        target="_blank"
                        >{{ getManagerCandidateById.webpage | prettifyUrl }}</a
                      >
                      <span
                        v-else
                        style="color: #0088cc; text-decoration: none; background-color: transparent"
                        >N/A</span
                      >
                    </div>
                  </div>
                </li>
                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Competencies</b>
                    </span>
                    <div class="edit-btn">
                      <router-link v-if="editFields.competences" to class="mr-1">
                        <i
                          @click="showEditForm($event)"
                          id="competences"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>

                    <div class="tech-icons dropdown">
                      <div
                        class="icon-container"
                        v-for="(competence, i) in getManagerCandidateById.competences
                          ? getManagerCandidateById.competences.slice(0, 4)
                          : []"
                        :key="i"
                      >
                        <IconMapper :competence="competence"></IconMapper>
                      </div>
                      <i
                        v-if="getManagerCandidateById.competences.length > 4"
                        class="fas fa-ellipsis-h"
                      ></i>

                      <button
                        class="btn btn-secondary dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      ></button>
                      <div
                        v-if="getManagerCandidateById.competences.length > 4"
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="list-inline">
                          <li
                            class="list-inline-item"
                            v-for="(subCompetence, $index) in getManagerCandidateById.competences
                              ? getManagerCandidateById.competences.slice(4)
                              : []"
                            :key="$index"
                          >
                            <IconMapper :competence="subCompetence"></IconMapper>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <!-- Start Dropdown list of competences -->
                  <div class="popup d-flex justify-content-around" v-if="showMore">
                    <div
                      class="text-center icon-container"
                      v-for="(competence, i) in getManagerCandidateById.competences"
                      :key="i"
                    >
                      <!--   <IconMapper :competence="competence"></IconMapper> -->
                    </div>
                  </div>
                  <!-- End dropdown competences -->
                </li>
                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Languages</b>
                    </span>
                    <div v-if="getManagerCandidateById.languages.length">
                      <span
                        v-for="language in filteredLanguages"
                        :class="['candidate-tag', 'mr-3']"
                        :key="language.id"
                        :id="language.id"
                        >{{ language }}</span
                      >
                    </div>
                    <div v-else>
                      <span>N/A</span>
                    </div>
                  </div>
                </li>
                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Employment</b>
                    </span>
                    <div>Employment</div>
                  </div>
                </li>
                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Created date</b>
                    </span>
                    <span v-if="!isInGlobalEditMode" class="creation-date">{{
                      getManagerCandidateById.created_at
                        | formatDate({
                          format: getManagerUserProfile.format_date,
                          timezone: getManagerUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}</span>
                    <span class="w-100" v-if="isInGlobalEditMode">
                      <input
                        class="form-control"
                        type="text"
                        disabled
                        :value="
                          getManagerCandidateById.created_at
                            | formatDate({
                              format: getManagerUserProfile.format_date,
                              timezone: getManagerUserProfile.timezone,
                              hasHourAndMinutes: false,
                            })
                        "
                      />
                    </span>
                  </div>
                </li>

                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Updated</b>
                    </span>
                    <span v-if="!isInGlobalEditMode" class="creation-date">{{
                      getManagerCandidateById.updated_at
                        | formatDate({
                          format: getManagerUserProfile.format_date,
                          timezone: getManagerUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}</span>
                    <span v-else class="w-100"
                      ><input
                        class="form-control"
                        disabled
                        type="text"
                        :value="
                          getManagerCandidateById.updated_at
                            | formatDate({
                              format: getManagerUserProfile.format_date,
                              timezone: getManagerUserProfile.timezone,
                              hasHourAndMinutes: false,
                            })
                        "
                    /></span>
                  </div>
                </li>
              </div>
            </ul>
          </form>
        </section>
      </div>

      <Spinner :isLoading="isLoading" />
      <div class="tab-pane fade" id="nav-cv" role="tabpanel" aria-labelledby="nav-cv-tab">
        <embed v-if="showCv" :src="defaultCv" width="100%" height="820px" type="application/pdf" />
        <span v-else>{{ previewCvMessage }}</span>
      </div>
      <div class="tab-pane fade" id="nav-doc" role="tabpanel" aria-labelledby="nav-doc-tab">
        <ManagerCandidateItemDocuments :header="false" />
      </div>
      <div
        class="tab-pane fade"
        id="nav-comments"
        role="tabpanel"
        aria-labelledby="nav-comments-tab"
      >
        <ManagerComments
          :key="key"
          @add-candidate-comment="addCommentHandler"
          @remove-comment="deleteCommentHandler"
          @edit-comment="editCommentHandler"
          :commentsList="getManagerCandidateComments"
        />
      </div>
      <div
        class="tab-pane fade"
        id="nav-activity"
        role="tabpanel"
        aria-labelledby="nav-activity-tab"
      >
        <!-- <Activities :activities="getManagerCandidateById.activities" /> -->
      </div>
      <div class="tab-pane fade" id="nav-emails" role="tabpanel" aria-labelledby="nav-emails-tab">
        <!--  <Emails :emails="getCandidateEmails" /> -->
      </div>
      <div
        class="tab-pane fade"
        id="nav-pipelines"
        role="tabpanel"
        aria-labelledby="nav-pipelines-tab"
      >
        <h6 class="pipelines-mobile-title">Pipelines</h6>
        <!--     <CandidateItemPipelineMobile /> -->
      </div>
    </div>

    <!-- End Delete Candidate Modal -->
    <!-- END ROW -->
  </div>
</template>

<script>
/* import CandidateEditFieldCancelBtn from '../common/CandidateEditFieldCancelBtn'; */
import ManagerComments from '../common/ManagerComments';
import { errorService } from '../../../services/errorService';
/* import Emails from '../common/Emails'; */
/* import CandidateItemPipelineMobile from './CandidateItemPipelineMobile'; */
/* import CustomMainModal from '@/components/Modals/CustomMainModal'; */
/* import Activities from '../common/Activities'; */
/* import AddCandidateBtnModal from './AddCandidateBtnModal'; */
import IconMapper from '../../common/iconMapper';
import ManagerCandidateItemDocuments from '../Candidates/ManagerCandidateItemDocuments';
import { MESSAGES } from '../../../constants';
/* import svgHelper from '../../common/svgHelper.vue'; */
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';

export default {
  components: {
    /*   CustomMainModal, */
    ManagerComments,
    IconMapper,
    ManagerCandidateItemDocuments,
    /*  svgHelper, */
  },
  watch: {
    '$route.params.manager_candidate_id': {
      handler(newParams, oldParams) {
        if (newParams !== oldParams) {
          this.$emit('candidateInfoUpdated');
        }
      },
      deep: true, // This is used to watch for changes within the object
    },
  },
  data: () => ({
    rand: '',
    defaultCv: '',
    previewCvMessage: '',
    isLoading: false,
    key: 0,
    showModal: false,
    showMore: false,
    relocation: false,
    optedOut: false,
    active: false,
    isInEditMode: false,
    isInGlobalEditMode: false,
    candidateId: '',
    candidateData: {},
    employmentType: '1',
    competences: [],
    competencesOptions: [],
    candidateLanguages: [],
    languagesOptions: [],
    selectedCountry: '',
    selectedCity: '',
    countryId: '',
    cityId: '',
    showCv: false,
    phone: '',
    editFields: {
      name: false,
      primaryEmail: false,
      secondaryEmail: false,
      phone: false,
      skype: false,
      streetAddr: false,
      postal: false,
      city: false,
      country: false,
      linkedin: false,
      webpage: false,
      competences: false,
      languages: false,
      employment: false,
      createdBy: false,
      sources: false,
      editRelocation: false,
      editOptedout: false,
    },
    editIconState: {
      nameFormShow: false,
      primaryEmailFormShow: false,
      secondaryEmailFormShow: false,
      phoneFormShow: false,
      skypeFormShow: false,
      streetAddrFormShow: false,
      postalFormShow: false,
      cityFormShow: false,
      countryFormShow: false,
      linkedinFormShow: false,
      webpageFormShow: false,
      competencesFormShow: false,
      languagesFormShow: false,
      employmentFormShow: false,
      createdByFormShow: false,
      relocationFormShow: false,
      optedoutFormShow: false,
      sourcesFormShow: false,
    },
    candidateToDelete: '',
    filteredLanguages: [],
  }),
  methods: {
    ...mapActions([
      'retrieveCitiesListByCountryId',
      'retrieveCandidateDocuments',
      'retrieveCandidateDocument',
      'retrieveCandidateAvatar',
      'retrieveCandidateById',
      'candidateDeleteAvatar',
      'candidateUpladAvatar',
      'editCandidateById',
      'deleteCandidate',
    ]),
    ...mapActions('managerStoreModule', [
      'addManagerCandidateComment',
      'retrieveManagerCandidateCommentsList',
      'editManagerCandidateComment',
      'removeManagerCandidateComment',
      'retrieveManagerCandidateDocumentPreview',
    ]),
    /* setCandidateToDelete(candidate) {
      this.candidateToDelete = candidate;
    }, */
    addCommentHandler(comment) {
      if (comment.message) {
        const normalizedComment = comment.message.trim();

        this.addManagerCandidateComment({
          uuid: this.$route.params.manager_candidate_id,
          message: normalizedComment,
          js_share: comment.share,
        })
          .then(() => {
            this.retrieveManagerCandidateCommentsList({
              uuid: this.$route.params.manager_candidate_id,
            });

            this.$toasted.success(MESSAGES.commentAddedSuccess, {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            });
          })
          .catch(err => {
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            });
          });
      } else {
        this.$toasted.info(MESSAGES.emptyComment, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 10000,
        });
      }
    },
    checkLinkedIin(url) {
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return 'https://' + url;
      } else {
        return url;
      }
    },
    editCommentHandler(commentData) {
      this.editManagerCandidateComment({ uuid: commentData.id, data: commentData.comment })
        .then(() => {
          this.retrieveManagerCandidateCommentsList({
            uuid: this.$route.params.manager_candidate_id,
          });
          this.$toasted.success(MESSAGES.commentUpdatedSuccess, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(() => {
          this.$toasted.error(MESSAGES.commentUpdatedError, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });
        });
    },
    deleteCommentHandler(commentID) {
      this.removeManagerCandidateComment({ uuid: commentID })
        .then(() => {
          this.retrieveManagerCandidateCommentsList({
            uuid: this.$route.params.manager_candidate_id,
          });

          this.$toasted.show(MESSAGES.commentDeletedSuccess, {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(err => {
          this.$toasted.error(err.response.data.message, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });
        });
    },
    fetchCitiesByCountryId(e) {
      this.selectedCountry = e;
      // this.countryId = e.id;

      this.retrieveCitiesListByCountryId({ id: this.selectedCountry.id });
    },
    setCityModel(e) {
      this.cityId = e;
    },
    oncompetenceSearch(search, loading) {
      if (search.length >= 3) {
        loading(true);
        this.competencesOptions = this.getCompetencesFilterList;
      }

      loading(false);
    },
    onLanguageSearch(search, loading) {
      if (search.length >= 3) {
        loading(true);
        this.languagesOptions = this.getLanguagesList;
      }

      loading(false);
    },
    forceRerender() {
      this.key += 1;
    },
    showMoreCompetences() {
      this.showMore = !this.showMore;
    },

    updateLocalCandidate(e) {
      this.$set(this.candidateData, e.target.id, e.target.value);
      /* this.$set(this.candidateData, 'selectedCountry', this.selectedCountry.id);
      this.$set(this.candidateData, 'selectedCity', this.selectedCity.id); */
    },
    changeGlobalEditMode() {
      this.isInGlobalEditMode = !this.isInGlobalEditMode;
    },

    onCvDocumentView() {
      this.isLoading = true;
      this.showCv = true;

      /*       const defaultDoc =
        this.getManagerCandidateById.documents.find(doc => doc.is_default === true) || null; */

      const defaultDoc = this.getManagerCandidateById.documents[0] || null;

      this.getManagerCandidateById.documents.length
        ? ''
        : (this.previewCvMessage = 'No documents have been uploaded.');

      if (defaultDoc) {
        this.retrieveManagerCandidateDocumentPreview({ uuid: defaultDoc.id, preview: true })
          .then(response => {
            this.isLoading = false;
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const objectUrl = URL.createObjectURL(blob);

            this.defaultCv = objectUrl;

            this.setPdfPreview(response.data.type);
          })
          .catch(() => {
            this.isLoading = false;
            this.defaultCv = null;
          });

        this.previewCvMessage = 'No documents have been uploaded';
      } else {
        this.showCv = false;
        this.previewCvMessage = 'No documents have been uploaded';
      }

      this.isLoading = false;
    },
    setPdfPreview(fileName) {
      if (fileName === 'application/pdf') {
        this.showCv = true;
      } else {
        this.previewCvMessage = 'Sorry, this document cannot be previewed.';
        this.showCv = false;
      }
    },

    seenProfile() {
      axios.post(
        `${process.env.VUE_APP_API_URL}/manager/pipelines/seendate`,
        {
          candidate_id: this.$route.params.manager_candidate_id,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
        },
      );
    },
  },
  computed: {
    ...mapGetters('managerStoreModule', [
      'getManagerCandidateById',
      'getManagerCandidateAvatar',
      'getManagerCandidateComments',
      'getManagerUserProfile',
      /* 'getCompetencesFilterList',
      'getCitiesListByCountry',
      'getCandidateDocuments',
      'getCandidateEmails',

      'getManagerCandidateById',
      'getCommentsList',
      'getAllCountries',
      'getUserProfile',
      'getLanguagesList', */
    ]),
  },
  mounted() {
    this.seenProfile();
    /*  this.retrieveCandidateById({
      manager_candidate_id: this.$route.params.manager_candidate_id,
    }).then(() => {
      this.filteredLanguages = new Set();
      this.getManagerCandidateById.languages.forEach((item) => {
        this.filteredLanguages.add(item.name);
      });

      this.retrieveCandidateAvatar({ uuid: this.$route.params.candidate_id });

      this.competences = this.getManagerCandidateById.competences;
      this.candidateLanguages = this.filteredLanguages;

      this.selectedCountry = this.getManagerCandidateById.country;
      this.selectedCity = this.getManagerCandidateById.city;
    }); */
  },
  updated() {
    this.candidateData = this.getManagerCandidateById;
    this.competences = this.getManagerCandidateById.competences;
    this.candidateLanguages = this.filteredLanguages;
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/_functions.scss';

.badge {
  background: mix($color-white, $btn-default-color, 50);
  color: #fff;
  margin-left: 5px;
  text-align: center;
  animation: pulse 2s infinite;
  animation-duration: pulse 10s;
  -webkit-animation-duration: 5s;
}

.manager-candidate-img {
  img {
    border: none !important;
  }
}

@keyframes pulse {
  0% {
  }
  50% {
    -moz-box-shadow: 0 0 0 0 $color-orange;
    box-shadow: 0 0 0 0 $color-orange;
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}

.opted-checkbox {
  margin-right: 1rem;
}

.pipelines-mobile-title {
  display: none;
}

.list-group {
  .list-group-item {
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
    background-color: transparent;
    padding-right: 0;
  }
}
.v-select {
  position: relative;
  top: -6px;
  margin-right: 5px;
}

.employment-select {
  font-family: $font-family-sans-lato;
  font-size: 13px;
  margin-top: -8px;
}

.candidate-edit {
  &-icon {
    fill: #a3a6b4;
    margin-top: -5px;
  }

  &-icon:hover {
    fill: #c1c4d4;
  }
}

.candidate-info-form {
  button {
    border-radius: 0.25rem;
    position: relative;

    i {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 12px;
    }
  }
  .edit-btn {
    width: 25px;
    height: 25px;
    a {
      text-decoration: none;
    }
    i {
      color: #777;
      display: block;
      width: 100%;
      text-decoration: none;
    }
    &.mr {
      margin: 0 6px 0 8px;
    }
  }

  .custom-checkbox {
    margin-left: 25px !important;
  }
}

.edit-icon {
  font-size: 1.1rem !important;
}

.candidate-details {
  font-family: $font-family-sans-lato;
  font-size: 0.875rem;
  overflow: hidden;

  .row {
    margin: 0;
  }

  li.list-group-item {
    padding-left: 0 !important;
    border: none !important;
  }

  li > .d-flex {
    border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
    margin: 3px 12px;
    padding: 12px 0;
    height: 46px;
  }

  li span {
    min-width: 130px !important;

    white-space: nowrap;
  }

  li > span:not(:nth-child(2n + 0)) {
    font-weight: 700;
    min-width: 19rem;
  }

  .popup {
    background: #fff;
    border: 1px solid #ddd;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
    position: absolute;
    padding: 8px 12px 6px 12px !important;
    top: 75%;
    left: -15px;
    width: 100%;
    height: auto !important;
    z-index: 9;
    flex-wrap: wrap;
  }

  .tech-icons {
    width: 100%;
    position: relative;
    margin-top: -20px;
    .icon-container {
      width: 22%;
      text-align: center;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .icon-wrapper {
        img {
          width: 25px;
          height: 25px;
          display: block;
          margin: 0 auto;
        }
      }
    }
    .btn-secondary {
      background: none !important;
      border: none !important;
      box-shadow: none !important;
      position: absolute;
      top: 13px;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .dropdown-menu {
      width: 100%;
      border-radius: 0;
      .list-inline {
        li {
          margin: 0;
          text-align: center;
          width: 25%;
        }
      }
    }
    .dropdown-toggle {
      &:after {
        display: none;
      }
    }
  }

  .btn {
    min-width: 22px;
    min-height: 12px;
    background: #fff;
    margin-top: -3px;
    color: #28a745;
    &:hover {
      background: #fafafa;
    }
    &:nth-of-type(2) {
      color: red;
    }
  }
}

.card-primary {
  height: 820px;
}

/* CANDIDATE TAGS */
.candidate-tag {
  border: 1px solid #a3a6b4;
  border-radius: 20px;
  color: #a3a6b4;
  padding: 6px 10px;
}

.candidate-tag-selected {
  cursor: pointer;
  color: $color-orange;
  border: 1px solid $color-orange;
}

.candidate-picture {
  position: relative;
  width: 64px;
  height: 64px;
  margin-right: 12px !important;
  flex-shrink: 0;
  .btn-success {
    margin-right: 10px;
  }
  .overlay {
    cursor: pointer;
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    font-size: 21px;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.125);
    opacity: 0;
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
  }
  &:hover {
    .overlay {
      opacity: 1;
    }
  }
}

.candidate-picture-preview {
  width: 13rem;
  height: 13rem;
}

.card {
  min-height: auto;
  .tab-content {
    margin: 1rem;
  }
}

.mobile-only {
  display: none !important;
}

.candidate-main-info {
  flex: 1;
  .candidate-name {
    flex: 1;
    .fields {
      flex: 1;
    }
  }
  .edit-candidate {
    margin-left: 6px;
    .btn-primary,
    .btn-danger {
      margin-left: 12px;
    }
  }
}

.custom-control {
  padding-left: 0;
}

@media only screen and (max-width: 576px) {
  .mobile-only-new {
    display: block !important;
  }
}

/* 
@media only screen and (max-width: 992px) {
  .card {
    min-height: auto;
    height: auto !important;
    overflow: hidden;
    .tab-content {
      margin: 0;
    }
  }
  .comments {
    padding: 0 18px;
  }

  .mobile-only {
    display: block !important;
  }
  .edit-btn {
    position: absolute;
    right: 5px;
  }
  .candidate-details {
    .row {
      margin: 0 12px;
    }
  }
}

@media only screen and (max-width: 768px) {
  .page-title {
    display: none !important;
  }
  .candidate-picture {
    .candidate-edit {
      width: 40%;
    }
  }
  .card {
    min-height: auto;
    height: auto !important;
    overflow: hidden;
    .tab-content {
      margin: 0;
    }
  }
  .candidate-details {
    .primary-cv {
      display: block !important;
    }
    .list-group-item {
      .d-flex {
      }
    }
  }
  .mobile-only {
    display: block !important;
  }
  .edit-btn {
    position: absolute;
    right: 5px;
  }
}


@media only screen and (max-width: 576px) {
.candidate-name{
font-size:11px!important
  }
  .card {
    min-height: 100%;
    padding-bottom: 40px;
    .tab-content {
      margin: 0;
    }
  }

  .candidate-details {
    margin-top: 20px;
    .btn {
      min-width: 30px !important;
      height: 30px;
      position: relative;
      top: -3px;
      margin-left: 6px;
      font-size: 14px !important;
    }
  }

  .candidate-picture {
    width: 43px !important;
    height: 43px !important;
    position: absolute;
    top: 10px;
    right: 20px;
    img {
      width: 43px !important;
      height: 43px !important;
      object-fit: cover;
    }
  }
  .edit-btn {
    position: absolute;
    right: 5px;
  }
  .candidate-details {
    .list-group-item {
      span {
        margin-right: 25px;
      }
      .mobile-name {
        margin-right: 27px !important;
      }
      .custom-checkbox {
        margin-left: 0px !important;
      }
      .tech-icons {
        padding-left: 0 !important;
        margin-left: -5px;
        span {
          margin-right: 0;
        }
      }
      .popup {
        span {
          margin-left: 0 !important;
          margin-right: 0 !important;
        }
      }
      .creation-date {
        margin-left: 0 !important;
      }
    }
  }
  .mobile-hidden {
    display: none !important;
  }
  .mobile-only {
    display: block !important;
  }
  .comments {
    padding: 8px;
  }
}
 */
/* CANDIDATE TAGS END*/
</style>
